<!--begin::Menu wrapper-->
<div id="kt_app_sidebar_menu_wrapper" class="app-sidebar-wrapper hover-scroll-overlay-y my-5" data-kt-scroll="true"
  data-kt-scroll-activate="true" data-kt-scroll-height="auto"
  data-kt-scroll-dependencies="#kt_app_sidebar_logo, #kt_app_sidebar_footer"
  data-kt-scroll-wrappers="#kt_app_sidebar_menu" data-kt-scroll-offset="5px" data-kt-scroll-save-state="true">

  <!--begin::Menu-->
  <div class="menu menu-column menu-rounded menu-sub-indention px-4" id="#kt_app_sidebar_menu" data-kt-menu="true"
    data-kt-menu-expand="false">

    <!--begin::Menu Items-->
    <div class="menu-item" *ngFor="let footerItem of footerItems">
      <a class="menu-link without-sub" [routerLink]="footerItem.route" routerLinkActive="active"
        [routerLinkActiveOptions]="footerItem.routerLinkActiveOptions">
        <span class="menu-icon ">
          <span [inlineSVG]="footerItem.icon" class="svg-icon svg-icon-2 "></span>
        </span>
        <span class="menu-title ">
          {{footerItem.title}}
        </span></a>
    </div>
    <!--end::Menu Items-->

  </div>
  <!--end::Menu-->
  
</div>
<!--end::Menu wrapper-->
<hr class="mx-4"/>
<app-navbar class="app-navbar flex-shrink-0 px-4 mt-7"></app-navbar>


